"use client";
import {
  Box,
  Button,
  Heading,
  Text,
  Stack,
  Highlight,
  UnorderedList,
  ListItem,
} from "@chakra-ui/react";
import Logo from "public/brand/logo.webp";
import {
  useSectionHeadingVariant,
  useTextVariants,
} from "@/theme/components/useSectionHeading";
import { BUTTON_VARIANTS } from "@/theme/components/button";
import { scrollToElement } from "@/utils/scrollToElement";

type Props = {
  title: string;
  desc: { highlight: string | string[]; text: string }[];
  points?: { highlight: string | string[]; text: string }[];
};

const BoxWithLogo = (props: Props) => {
  const { title, desc, points } = props;
  const HeadingVariant = useSectionHeadingVariant();
  const TextVariant = useTextVariants();

  return (
    <Stack
      position="relative"
      spacing={6}
      p={8}
      borderColor={"primary.300"}
      borderRadius={"16px"}
      borderWidth={"1px"}
      className="brand-shadow"
    >
      <Heading as="h1" variant={HeadingVariant} textAlign={"center"}>
        {title}
      </Heading>
      <Box
        position="absolute"
        top={20}
        left={10}
        right={10}
        bottom={12}
        backgroundImage={`url(${Logo.src})`}
        backgroundSize="contain"
        backgroundPosition="center"
        backgroundRepeat="no-repeat"
        opacity={0.1}
        zIndex={-1}
      />

      <Stack spacing={4}>
        {desc.map((item, index) => (
          <Text key={index} variant={TextVariant}>
            <Highlight styles={{ fontWeight: 600 }} query={item.highlight}>
              {item.text}
            </Highlight>
          </Text>
        ))}
      </Stack>
      {points && (
        <UnorderedList spacing={1}>
          {points.map((item, index) => (
            <ListItem key={index}>
              <Text variant={TextVariant}>
                <Highlight styles={{ fontWeight: 600 }} query={item.highlight}>
                  {item.text}
                </Highlight>
              </Text>
            </ListItem>
          ))}
        </UnorderedList>
      )}
      <Button
        onClick={() => scrollToElement("contact-us", 120)}
        variant={BUTTON_VARIANTS.PRIMARY}
        minW={"150px"}
        alignSelf={"center"}
      >
        Talk To Us
      </Button>
    </Stack>
  );
};

export default BoxWithLogo;
